import { fetchAll, fetchFiltered, edit, add, show } from '@/api/servicetypes'

const state = {
  all: [],
  isLoading: false,
  serviceTypeById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const servicetypes = await fetchAll()
      commit('setAll', servicetypes)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const serviceType = await show(id)
      commit('setServiceTypeById', serviceType)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const serviceTypes = await fetchFiltered(queriesParams)
      commit('setAll', serviceTypes)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', { message: t(e.message) + ' já cadastrado!' || e }, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async create ({ dispatch, commit }, serviceType) {
    commit('setLoading', true)
    try {
      await add(serviceType)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.serviceTypeById = null
  },

  setAll (state, servicetypes) {
    state.all = servicetypes
  },

  setServiceTypeById (state, serviceType) {
    state.serviceTypeById = serviceType
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
